"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoPlay = void 0;
var _jsxRuntime = require("react/jsx-runtime");
const VideoPlay = () => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      transform: "translate(-139 -98)",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        transform: "translate(139 98)",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "M167.071,161.434c-.555.321-1.009.058-1.009-.583V137.4c0-.641.454-.9,1.009-.583l20.3,11.726a.616.616,0,0,1,0,1.166Z",
          transform: "translate(-136.22 -111.625)"
        })
      })
    })
  });
};
exports.VideoPlay = VideoPlay;